import React from "react";

import "./style.scss";
import {useTranslation} from "react-i18next";

const ReserveDetail = ({data, cancel, getDetail}) => {
  const {t} = useTranslation();
  return (
    <div className="reserveDetail-container">
      <div className="top-section">
        {t("bookslot.heading")} - {data.businessUnit} - {data.storeName}
      </div>
      <div className="border-seperator"></div>
      <div className="bottom-section">
        <div className="bottom-first-section" onClick={cancel}>
          {t("cancel.reservation.title")}
        </div>
        <div
          className="bottom-first-section bottom-second-section"
          onClick={getDetail}
        >
          {t("view.detail")}
        </div>
      </div>
    </div>
  );
};

export default ReserveDetail;
